__turbopack_context__.v({
  "container": "LpHero-module__-KZAnW__container",
  "description": "LpHero-module__-KZAnW__description",
  "hero": "LpHero-module__-KZAnW__hero",
  "image": "LpHero-module__-KZAnW__image",
  "imageContainer": "LpHero-module__-KZAnW__imageContainer",
  "textContent": "LpHero-module__-KZAnW__textContent",
  "title": "LpHero-module__-KZAnW__title",
});
